import { render, staticRenderFns } from "./jicaiListB.vue?vue&type=template&id=1a0ffa8b&"
import script from "./jicaiListB.vue?vue&type=script&lang=js&"
export * from "./jicaiListB.vue?vue&type=script&lang=js&"
import style0 from "./jicaiListB.vue?vue&type=style&index=0&id=1a0ffa8b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports